// launchdarkly-flag.pipe.ts
import { Pipe, PipeTransform } from "@angular/core";
import { LaunchDarklyService } from "../../launchdarkly.service";

@Pipe({ name: "ldFlag", pure: false })
export class LaunchDarklyFlagPipe implements PipeTransform {
  constructor(private ld: LaunchDarklyService) {}

  transform(flagKey: string, defaultVal: any = false): any {
    return this.ld.getFlag(flagKey, defaultVal);
  }
}

/********************************************
 * <!-- Disable a button if the flag is off -->
 * <button [disabled]="!('accreditations' | ldFlag)">
 *   Create Accreditation
 * </button>
 *
 * <!-- Toggle a CSS class based on a flag -->
 * <div [class.beta-enabled]="'betaFeatureX' | ldFlag">
 *   This block has a beta style applied if the feature is enabled.
 * </div>
 *
 * <!-- Fallback default value (flag not found) -->
 * <p *ngIf="'newHomepage' | ldFlag : false">
 *   Welcome to the new homepage experience!
 * </p>
 *
 ********************************************/
